<template>
  <v-layout row class="my-0">
    <v-flex
      text-xs-center
      :key="i"
      v-for="(indicator, i) in indicators"
    >
      <v-tooltip top>
        <img
          slot="activator"
          height="24px"
          :src="require('@/' + indicator.color.iconPath)" alt="indicator-icon"
        >
        <span>{{ indicator.text }}</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import cardsStorage from './../../storage/cardsStorage'

export default {
  data () {
    return {
      cards: []
    }
  },
  mounted () {
    this.cards = cardsStorage.getCardsPointer().cards
  },
  methods: {},
  props: {
    indicators: {
      type: Array,
      default () {
        return []
      }
    },
    distributor: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/distributor-details-indicators-list.vue